// popup.js
// 表示しない人（2026-10-28 追加）: ログイン中でメール配信に同意している会員（theme.liquid で読み込まない）／登録済み／メルマガのリンクから来て90日以内／×で閉じてから30日以内。
// 中央のメルマガポップアップ（snippets/re-nl-popup.liquid）と同じ localStorage「re_nl_popup」を読み書きする。
// 登録済み・メルマガの印は snippets/re-nl-mark.liquid が付ける。どちらかを閉じれば、もう一方も30日出ない。
var BLOG_POPUP_STATE_KEY = 're_nl_popup';
var BLOG_POPUP_DISMISS_DAYS = 30;
var BLOG_POPUP_MAIL_DAYS = 90;

function loadBlogPopupState() {
  try { return JSON.parse(localStorage.getItem(BLOG_POPUP_STATE_KEY)) || {}; } catch (e) { return {}; }
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname.includes('/blogs/contents/')) {
    const excludeUrls = [
      '/blogs/contents/high-end_sake_present', // 最高級,カンマを忘れないこと！
      '/blogs/contents/wedding-gift', // 結婚祝い,カンマを忘れないこと！
      '/blogs/contents/expensive-sake-present',  // 高級ギフト,カンマを忘れないこと！
      '/blogs/contents/oseibo-gift',  // お歳暮,カンマを忘れないこと！
      '/blogs/contents/sparkling-sake',  // スパークリング,カンマを忘れないこと！
      '/blogs/contents/reishu-recommend',  // 冷酒,カンマを忘れないこと！
      '/blogs/contents/sake-hot',  // 熱燗,カンマを忘れないこと！
      '/blogs/contents/miyagi-select',  // 宮城おすすめ,カンマを忘れないこと！
      '/blogs/contents/the-most-expesive-ranking-10',  // 高級ランキング,カンマを忘れないこと！
    ];
    
    if (!excludeUrls.some(url => window.location.pathname.includes(url))) {
      const isPopupClosed = sessionStorage.getItem('popupClosed');
      const state = loadBlogPopupState();
      const recentlyDismissed = state.dismissed_at && Date.now() - state.dismissed_at < BLOG_POPUP_DISMISS_DAYS * 864e5;
      const recentMailVisit = state.mail_seen_at && Date.now() - state.mail_seen_at < BLOG_POPUP_MAIL_DAYS * 864e5;

      if (!isPopupClosed && !state.subscribed && !recentMailVisit && !recentlyDismissed) {
        setTimeout(showPopup, 5000);
      }
    }
  }
});

function showPopup() {
  const popupStyles = `
    <style>
      #myPopup {
        display: none;
        position: fixed;
        bottom: 30px;
        right: 30px;
        z-index: 1000;
        background-color: white;
        padding: 0;
        border-radius: 12px;
        box-shadow: 0 4px 24px rgba(0,0,0,0.12);
        max-width: 320px;
        width: 320px;
        transition: opacity 0.3s ease-in-out;
      }

      /* スマートフォン向けスタイル */
      @media screen and (max-width: 767px) {
        #myPopup {
          bottom: 20px;
          right: 20px;
          max-width: 240px;
          width: 240px;
        }
      }

      #popupCloseBtn {
        position: absolute;
        top: -12px;
        right: -12px;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background-color: #333;
        color: white;
        border: 2px solid white;
        font-size: 14px;
        text-align: center;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        transition: all 0.2s ease;
        z-index: 1;
      }

      #popupImage {
        width: 100%;
        height: auto;
        border-radius: 12px;
        display: block;
      }
    </style>
  `;

  const popupHTML = `
    ${popupStyles}
    <div id="myPopup">
      <button id="popupCloseBtn" onclick="closePopup()">&times;</button>
       <!--
      <a href="/blogs/news/2024_nomiosame_omatome" style="display: block; text-decoration: none;">
        <img id="popupImage" src="https://cdn.shopify.com/s/files/1/0751/5157/3278/files/241220-sale-popup01.png?v=1734686558" alt="年末年始の飲み治め" />
      </a>
      -->
      <a href="/pages/newsletter?utm_source=shopify&utm_medium=floating_cta&utm_campaign=newsletter&utm_content=article" style="display: block; text-decoration: none;">
        <img id="popupImage" src="https://cdn.shopify.com/s/files/1/0751/5157/3278/files/mail-magazine-register-popup-600x300-04.png?v=1777627289" alt="メルマガ登録で10%OFFクーポンプレゼント" />
      </a>
      <!--
      <a href="https://lin.ee/135Qt5X" style="display: block; text-decoration: none;">
        <img id="popupImage" src="https://cdn.shopify.com/s/files/1/0751/5157/3278/files/line-register-popup-300x150-01.png?v=1738573320" alt="LINE登録" />
      </a>
      -->
    </div>
  `;
  
  document.body.insertAdjacentHTML('beforeend', popupHTML);
  
  // ポップアップを表示する（フェードイン効果付き）
  const popup = document.getElementById('myPopup');
  if (popup) {
    popup.style.display = 'block';
    popup.style.opacity = '0';
    setTimeout(() => {
      popup.style.opacity = '1';
    }, 50);
  }
}

function closePopup() {
  const popup = document.getElementById('myPopup');
  if (popup) {
    // フェードアウト効果を追加
    popup.style.opacity = '0';
    setTimeout(() => {
      popup.style.display = 'none';
      popup.remove();
    }, 300);
    try {
      const state = loadBlogPopupState();
      state.dismissed_at = Date.now();
      localStorage.setItem(BLOG_POPUP_STATE_KEY, JSON.stringify(state));
    } catch (e) {}
    sessionStorage.setItem('popupClosed', 'true');
  }
}